import { ISourceGoldPrice } from 'api/types/_campaign';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_INFO, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import LabelWrapper from 'components/Common/LabelWrapper';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { SECTION_KEYWORD, STATUS_CAMPAIGN_OPTIONS } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { deleteSourceGoldPrice, getAllCampaignGoldPrice, getArticleGoldPricesNormal, getArticleGoldPrices as onGetArticleGoldPrices } from "../../../store/thunks";
import HighlightText from 'pages/News/Components/HighlightText';
import DropdownOption from 'components/Common/DropdownOption';
import ModalPreviewArticle from './ModalPreviewArticle';
import { INews, INewsGenerate } from 'api/types/_news';
export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'id';

registerLocale('en', en);
registerLocale('ko', ko);

const ArticleList = (activeTab?: any) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const isFirstLoadingPageRef = useRef<any>(true);

    const STATUS_CAMPAIGN_OPTIONS_LANG: any = STATUS_CAMPAIGN_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        section: withDefault(StringParam, `${SECTION_KEYWORD.CONTENT_APPTECH}`),
        title: withDefault(StringParam, ''),
        // start_date: withDefault(StringParam, START_DATE),
        // end_date: withDefault(StringParam, END_DATE),
        // campaign_id: withDefault(StringParam, ''),
        campaign_name: withDefault(StringParam, ''),
        type_page_no_param: withDefault(StringParam, ''),

    });

    const [campaigns, setCampaigns] = useState<{ label: string, value: string, name: string }[]>([]);

    const [titleSearch, setTitleSearch] = useState<string>(query?.title || "");

    const [campaignNameSearch, setCampaignNameSearch] = useState<string>(query?.campaign_name || "");

    const [campaignSearch, setCampaignSearch] = useState<Option | null>(campaigns?.find((item) => String(item?.value) === String(query?.campaign_id)) || null);

    const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_CAMPAIGN_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.is_active)) || null);

    const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateSearch;

    const [appDetail, setAppDetail] = useState<ISourceGoldPrice | null>(null);

    const [newsDetail, setNewsDetail] = useState<INews | null>(null);

    const [listNews, setListNews] = useState<{ list: INews[], total: number }>({ list: [], total: 0 });
    const [isListNewsLoading, setIsListNewsLoading] = useState<boolean>(false);

    const [idLoading, setIdLoading] = useState<string | number | null>(null);

    const [isShowPrompt, setIsShowPrompt] = useState<boolean>(false);
    const [promptShow, setPromptShow] = useState<string>('');

    const dispatch: any = useDispatch();

    const handleQueryData = async () => {
        setIsListNewsLoading((prev) => true);
        if (isFirstLoadingPageRef?.current === true && query?.page !== 1) {
            setQuery({
                ...query,
                type_page_no_param: '',
                page: 1
            });
            return;
        }
        isFirstLoadingPageRef.current = false;
        const res: any = await getArticleGoldPricesNormal(query);
        setListNews((prev: any) => ({
            list: res?.data?.list || [],
            total: res?.data?.pagination?.total || 0,
        }));
        setIsListNewsLoading((prev) => false);

        if (!!newsDetail && query?.type_page_no_param) {
            if (query?.type_page_no_param === 'prev') {
                setNewsDetail((_prev) => res?.data?.list[res?.data?.list?.length - 1]);
                return;
            }
            if (query?.type_page_no_param === 'next') {
                setNewsDetail((_prev) => res?.data?.list[0]);
                return;
            }
        }
    };

    const handleLoadMore = () => {
        setQuery({
            ...query,
            page: query?.page + 1,
            type_page_no_param: 'next'
        });
    }

    const handleLoadPrev = () => {
        setQuery({
            ...query,
            page: query?.page - 1,
            type_page_no_param: 'prev'
        });
    }


    useEffect(() => {
        handleQueryData();
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            title: titleSearch || '',
            campaign_name: campaignNameSearch || '',
            campaign_id: campaignSearch?.value || '',
            page: 1,
            time_request: + new Date()
        };
        if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
            setListNews((prev: any) => ({
                list: [],
                total: 0,
            }));
        }
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            title: '',
            campaign_name: '',
            campaign_id: '',
            sort_by: TYPE_SELECT_DEFAULT,
            order_by: 'DESC',
            page: 1,
            time_request: + new Date(),
        };
        if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
            setListNews((prev: any) => ({
                list: [],
                total: 0,
            }));
        }
        setQuery(queryNew, "push");
        setCampaignSearch(null);
        setCampaignNameSearch((_prev) => "");
        setTitleSearch((_prev) => "");
    };

    const triggerRefresh = async (type: string = '') => {
        onCloseClick();
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
    }
    //End::Update

    const handleSetAppDetail = (detail: ISourceGoldPrice | null) => {
        setAppDetail((_prev) => detail);
    }

    const handleShowPrompt = (_prompt: string = '') => {
        setPromptShow((_prev) => _prompt);
        setIsShowPrompt((_prev) => true);
    }

    // Begin::Delete

    const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
    const [initialValuesDefault, setInitialValuesDefault] = useState<ISourceGoldPrice | null>(null);

    const handleConfirmDelete = (item: ISourceGoldPrice) => {
        setInitialValuesDefault((_prev) => item);
        setIsConfirm((_prev) => true);
    };

    const handleActionDelete = async () => {
        if (!(initialValuesDefault?.id)) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteSourceGoldPrice({ ids: [initialValuesDefault?.id] });
            if (response?.code === 200) {
                dispatch(onGetArticleGoldPrices(query));
                setIsConfirmLoading((_prev) => false);
                setIsConfirm((_prev) => false);
                setInitialValuesDefault((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setInitialValuesDefault((_prev) => null);
        setIsConfirm((_prev) => false);
    }
    // End::Delete

    const handleSetNewsDetail = (detail: INews | null) => {
        setNewsDetail((_prev) => detail);
    }

    const onCloseClick = () => {
        handleSetNewsDetail(null);
    }

    // const scrollModalBodyToTop = () => {
    //     if (modalBodyInnerRef.current) {
    //         modalBodyInnerRef.current.scrollTo({ top: 0 });
    //     }
    //     if (modalSourceInnerRefs.current) {
    //         modalSourceInnerRefs.current.forEach((ref: any) => {
    //             if (ref) {
    //                 ref.scrollTo({ top: 0 });
    //             }
    //         });
    //     }
    // };

    const handlePreviousNews = (index_news_current: number = 0) => {
        if (listNews?.list?.length) {
            const indexNewsPrevious = Number(index_news_current) - 1;
            const newsPrevious = listNews?.list[indexNewsPrevious];
            if (!!newsPrevious) {
                handleSetNewsDetail({
                    ...(newsPrevious),
                    index: indexNewsPrevious,
                    disabled_prev: false,
                    disabled_next: false
                });

            }
            if (!newsPrevious) {
                if (Number(query?.page) > 1) {
                    handleLoadPrev();
                } else {
                    toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
                }
            }
        }
    };

    const handleNextNews = (index_news_current: number = 0) => {
        if (listNews?.list?.length) {
            const indexNewsNext = Number(index_news_current) + 1;
            const newsNext = listNews?.list[indexNewsNext];
            if (!!newsNext) {
                handleSetNewsDetail({
                    ...(newsNext),
                    index: indexNewsNext,
                    disabled_prev: false,
                    disabled_next: false,
                });
            }
            if (!newsNext) {
                if (Number(query?.page) < Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))) {
                    handleLoadMore();
                } else {
                    toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
                }
            }
        }
    };

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                thWidth: 80,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => (
                    <>
                        <div style={{ minWidth: '60px' }}>{cell?.value}</div>
                    </>
                ),
            },
            // {
            //     Header: t('Campaign'),
            //     accessor: "campaign",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 120,
            //     thClass: 'text-start align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (<>
            //             <div style={{ minWidth: '130px' }} className="d-flex flex-wrap">
            //                 {item?.news_campaign?.campaign_name || '-'}
            //             </div>
            //         </>)
            //     },
            // },
            {
                Header: t('News Title'),
                accessor: "title",
                filterable: true,
                sortable: false,
                thWidth: !listNews?.list?.length ? 100 : (window.innerWidth < 1650 ? 270 : 600),
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '450px', maxWidth: '600px' }} className="fs-15  d-flex align-items-center" onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ...item, index: cell?.row?.index }) }}>
                            <div className="cursor-pointer hover-underline"><HighlightText text={item?.title || ''} keyword={item?.keyword || ''} opacity_bg={0.7} /></div>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Date'),
                accessor: "date",
                filterable: true,
                sortable: false,
                thWidth: 120,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (<>
                        <div style={{ minWidth: '100px' }} className="d-flex flex-wrap">
                            {arrDate?.[0] || ''}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            // {
            //     Header: t('Updated At'),
            //     accessor: "updated_at",
            //     filterable: true,
            //     sortable: true,
            //     thWidth: 120,
            //     thClass: 'align-middle text-end',
            //     Cell: (cell: any) => {
            //         const arrDate = String(cell?.value || '').split(' ');
            //         return (
            //             <div className="text-end pe-3" style={{ minWidth: '100px' }}>
            //                 <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
            //             </div>
            //         )
            //     },
            // },
            // {
            //     Header: t('Actions'),
            //     accessor: "__",
            //     thClass: 'align-middle text-center',
            //     thWidth: 120,
            //     sortable: false,
            //     Cell: (cell: any) => {
            //         const item: any = cell?.row?.original;
            //         return (
            //             <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '90px' }}>
            //                 {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_GOLD_PRICE_UPDATE, userPermissions) && <TooltipCustom
            //                     title={t('Button Update Source')}
            //                     id={`update-us-${item?.id}`}
            //                 >
            //                     <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
            //                         <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
            //                             onClick={(e) => { e.preventDefault(); handleSetAppDetail(item) }}
            //                         >
            //                             <i className="ri-pencil-fill align-bottom"></i>
            //                         </Link>
            //                     </li>
            //                 </TooltipCustom>}
            //                 {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_GOLD_PRICE_DELETE, userPermissions) && (
            //                     <TooltipCustom
            //                         title={t('Button Delete Source')}
            //                         id={`detail-cp-${item?.id}`}
            //                     >
            //                         <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
            //                             <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
            //                                 onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
            //                             >
            //                                 <i className="ri-delete-bin-3-fill align-bottom"></i>
            //                             </Link>
            //                         </li>
            //                     </TooltipCustom>
            //                 )}
            //             </ul>
            //         );
            //     },
            // },
        ],
        [i18n?.language, idLoading, JSON.stringify(userPermissions), listNews?.list?.length]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleCallAllOption = async () => {
        try {
            // const [res1]: any = await Promise.all([getAllCampaignGoldPrice({})]);
            // const _list_campaign = (res1?.data || [])?.map((ml: any, index: number) => ({ value: String(ml?.id), label: ml?.name }));
            // setCampaigns((_prev: any) => _list_campaign);

            // if (query?.campaign_id) {
            //     const _val = (_list_campaign)?.find((s: any) => String(s?.value) === String(query?.campaign_id));
            //     setCampaignSearch(_val);
            // }

        } catch (error: any) {
            return error;
        }
    };

    const handleChangePicker = (values: any[] = []) => {
        setDateSearch((_prev: any) => values);
    }

    useEffect(() => {
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_GOLD_PRICE_LIST, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm-7">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isListNewsLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={listNews?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">
                                    {/* <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Campaign')} isShow={!!campaignNameSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Campaign')}...`}
                                                value={campaignNameSearch}
                                                onChange={(e) => setCampaignNameSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col> */}
                                    <Col sm={6} md={6} lg={6} xl={4} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('News Title')} isShow={!!titleSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('News Title')}...`}
                                                value={titleSearch}
                                                onChange={(e) => setTitleSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    {/* <Col sm={6} md={6} lg={6} xl={6} xxl={3} className='date-picker-wrapper-custom mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                            <DatePickerCustom
                                                placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                startDate={startDate || null}
                                                endDate={endDate || null}
                                                onChangePicker={handleChangePicker}
                                                showOptions={[
                                                    'today', 'yesterday', 'two_day_ago',
                                                    'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                    'this_week', 'last_week',
                                                    'this_month', 'last_month',
                                                ]}
                                            />
                                        </LabelWrapper>
                                    </Col> */}
                                    <Col sm={6} md={6} lg={6} xl={8} xxl={9} className="hstack gap-1 justify-content-center justify-content-sm-start mt-3">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isListNewsLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card "
                                    tableClass="align-middle sticky-table-article-gold-price"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={listNews?.list?.length ? listNews?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={listNews?.total}
                                    customPageCount={Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isListNewsLoading}
                                    isShowPagination={true}
                                    isShowLoadingBottom={false}
                                    isScrollToTop={true}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <ModalPreviewArticle
                isOpen={!!newsDetail}
                detail={newsDetail}
                isListNewsLoading={isListNewsLoading}
                type_page_no_param={query?.type_page_no_param}
                onClose={onCloseClick}
                triggerRefresh={triggerRefresh}
                handlePreviousNews={handlePreviousNews}
                handleNextNews={handleNextNews}
            />

            <Modal
                isOpen={!!isShowPrompt}
                centered={true}
                size="lg"
                scrollable={true}
                toggle={() => setIsShowPrompt(() => false)}
            >
                <ModalHeader toggle={() => setIsShowPrompt(() => false)}>
                    <>{t("Prompt")}</>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className="fs-15" style={{ whiteSpace: 'break-spaces' }}>
                        {promptShow || ''}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center">
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => setIsShowPrompt(() => false)}
                            style={{ width: '100px' }}
                        >
                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default ArticleList;